module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/product/trello 2-d5a8460a039d24588a100c2e5ab1d36f.svg";